'use strict';
const angular = require('angular');
// var baseUrl = 'http://localhost:3000'; //Local
var baseUrl = 'https://jsapi.mtcanalytics.org:10000' //Test and Production

// var adminBaseURL = 'http://localhost:10000'; //Local
var adminBaseURL = 'https://jsapi.mtcanalytics.org:11000' //Test and Production

/*@ngInject*/
export function baseConfigService() {
	  //Base URL
    this.getBaseURL = function () {
      return baseUrl;
    };

     //Auth Base URL
     this.getAdminBaseURL = function () {
      return adminBaseURL;
    };
}

export default angular.module('appApp.baseConfig', [])
  .service('baseConfigService', baseConfigService)
  .name;



// WEBPACK FOOTER //
// ./client/components/services/baseConfig/baseConfig.service.js